export default "__VITE_ASSET__CahH_GdQ__"